import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Reveal } from "./Reveal";

const QUOTES = [
  {
    speed: 0.1,
    text: "La salud mental es tan importante como la salud física.",
    author: "— OMS",
    style: { top: 0, right: 10 },
  },
  {
    speed: 0.18,
    text: "Pedir ayuda no es debilidad. Es el primer acto de valentía.",
    author: "— Anónimo",
    style: { top: 280, right: 90 },
  },
];

export function Hero() {
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const onScroll = () => setScrollY(window.scrollY);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div style={{
      position: "relative",
      background: "radial-gradient(1100px 520px at 78% -8%, #4a4339, #33302B)",
      overflow: "hidden",
    }}>
      {/* decorative blobs */}
      <div className="blob" style={{
        position: "absolute", left: -80, top: 120, width: 340, height: 340,
        background: "var(--sage)", borderRadius: "60% 40% 50% 50% / 55% 50% 50% 45%",
        opacity: 0.16, filter: "blur(10px)",
      }} />
      <div className="blob" style={{
        position: "absolute", right: 90, bottom: -40, width: 260, height: 260,
        background: "#C99A6E", borderRadius: "50%", opacity: 0.15, filter: "blur(10px)",
        animationDelay: "-4s",
      }} />
      <img src="/logo-psicodosis.png" alt="" style={{
        position: "absolute", right: -120, top: 40, width: 520, opacity: 0.07, pointerEvents: "none",
      }} className="hide-mobile" />

      <div className="container" style={{ position: "relative", paddingTop: 100 }}>
        <div className="grid-2" style={{ padding: "56px 0 96px" }}>
          <Reveal>
            <div>
              <div className="label-eyebrow" style={{
                background: "rgba(156,184,159,.16)", border: "1px solid rgba(156,184,159,.3)", color: "#C2D6C5", marginBottom: 26,
              }}>
                ● Una comunidad de bienestar mental
              </div>
              <h1 className="fluid-heading" style={{
                fontFamily: "var(--font-display)", fontWeight: 800, lineHeight: 1.03,
                letterSpacing: "-0.03em", margin: "0 0 22px", color: "var(--on-dark)",
              }}>
                No tienes que <span style={{ color: "var(--copper)" }}>hacerlo solo</span>
              </h1>
              <p className="hero-subtitle" style={{ lineHeight: 1.55, color: "var(--on-dark-muted)", margin: "0 0 34px", maxWidth: 460 }}>
                Guías psicoeducativas gratis, material de apoyo y una comunidad cálida que se acompaña. Empieza por el tema que hoy necesitas cuidar.
              </p>
              <div className="hero-actions">
                <Link to="/registro" className="btn btn-dark btn--lg">Únete a la comunidad</Link>
                <a href="#como-funciona" className="btn btn-ghost-light">Cómo funciona</a>
              </div>
            </div>
          </Reveal>

          {/* Tarjetas flotantes con frases — parallax al hacer scroll */}
          <div className="hide-mobile" style={{ position: "relative", height: 460 }}>
            {QUOTES.map((q, i) => (
              <div
                key={q.author}
                className="quote-float-card"
                style={{
                  ...q.style,
                  transform: `translateY(${scrollY * q.speed}px)`,
                  animationDelay: `${i * 0.15}s`,
                }}
              >
                <span className="quote-float-card__mark">&ldquo;</span>
                <div className="quote-float-card__text">{q.text}</div>
                <div className="quote-float-card__author">{q.author}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
